import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addleavetype',
  templateUrl: './addleavetype.component.html',
  styleUrls: ['./addleavetype.component.css']
})
export class AddleavetypeComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="LeaveType"; 
//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
leavetypeColl:any=[];
leavetypeBO:any={};

leavetypeid:number=0

leavetypeform=new FormGroup({
  leavetypeid:new FormControl(0),          
  leavetype:new FormControl('',Validators.required), 
  isannualleave:new FormControl(false),   
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.leavetypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.leavetypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.leavetypeid>0){
         this.fngetLeaveType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.leavetypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.leavetypeform.setValue({
    leavetypeid:0,    
    leavetype:'',
    isannualleave:false,
     inactive:false              
   })
}

//Get 
fngetLeaveType() { 
  if (this.showProgress) {
    return;
  }        
     var data = {
       'leavetypeid':this.leavetypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getLeaveType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){
          this.fnHideProgress();
  
           this.leavetypeColl=res.json().result;
           var editdata = this.leavetypeColl[0];        
           this.fnEditMode(editdata);
           this.leavetypeBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{       
      this.fnHideProgress();
   
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.leavetypeform.valid){ this.saveloading = true;
         //Check
         var data = {
               'leavetypeid': this.leavetypeid,                      
               'leavetype':this.leavetypeform.get('leavetype').value,
               'isannualleave':this.leavetypeform.get('isannualleave').value,        
               'inactive':this.leavetypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckLeaveType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.leavetypeform.get('leavetypeid').value>0){
                       //Update 
                       this.fnSetLeaveType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertLeaveType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;

                       this.leavetypeform.controls['leavetype'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;

               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;

             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;

     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertLeaveType(data){    
 
   this.appService.fnInsertLeaveType(data).subscribe(
     (res)=>{ this.saveloading = false;

       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new leavetype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.leavetypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;

       this.toastr.error('Error', err);
     });

}

//Set
fnSetLeaveType(data){    

this.appService.fnSetLeaveType(data).subscribe(
 (res)=>{ this.saveloading = false;

   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The leavetype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.leavetypeid,data.leavetypename);

             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;

   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/LeaveType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.leavetypeform.setValue({ 
  leavetypeid:deptBO.leavetypeid,     
  leavetype:deptBO.leavetype,
  isannualleave:deptBO.isannualleave,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}








}
